import { render, staticRenderFns } from "./ShopMenuHeader.vue?vue&type=template&id=083f06ad&"
import script from "./ShopMenuHeader.vue?vue&type=script&lang=js&"
export * from "./ShopMenuHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083f06ad')) {
      api.createRecord('083f06ad', component.options)
    } else {
      api.reload('083f06ad', component.options)
    }
    module.hot.accept("./ShopMenuHeader.vue?vue&type=template&id=083f06ad&", function () {
      api.rerender('083f06ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/ShopMenuHeader.vue"
export default component.exports